export const EVENT_OUTER_CLICK = 'header:outer-click';



// WEBPACK FOOTER //
// ./app/components/header/js/header-events.js